<template>
  <InViewport @center-change="centerChange" @top-change="topChange" @bottom-change="bottomChange">
    <div :class="['dh-psy-reveal', { 'dh-psy-reveal--centered': centered }]" slot="item">
      <div class="dh-psy-reveal__bg">
        <slot name="bg">
          <div class="dh-psy-reveal__default-bg"></div>
        </slot>
      </div>
      <slot name="item" prop="prop"></slot>
    </div>
  </InViewport>
</template>

<script>
import InViewport from '../Utilities/InViewport.vue'

export default {
  props: {
    thresholdTop: {
      type: Number,
      default: 33.333
    },
    thresholdBottom: {
      type: Number,
      default: 66.666
    },
    topPoint: {
      type: String,
      required: false,
      default: 'top',
      validator(value) {
        return ['center', 'top', 'bottom'].includes(value)
      }
    },
    bottomPoint: {
      type: String,
      required: false,
      default: 'bottom',
      validator(value) {
        return ['center', 'top', 'bottom'].includes(value)
      }
    }
  },
  data() {
    return {
      top: 0,
      bottom: 0,
      center: 0
    }
  },
  computed: {
    visibility() {
      return this[this.topPoint] > 0
    },
    centered() {
      return (
        this[this.topPoint] > this.thresholdBottom && this[this.bottomPoint] < this.thresholdTop
      )
    }
  },
  watch: {
    top(value) {
      this.$emit('onTopChange', value)
    },

    visibility(value) {
      this.$emit('onVisibilityChange', value)
    },
    centered(value) {
      this.$emit('onCenteredChange', value)
      const el = document.querySelector('.dh-psy-masthead')

      if (!el) {
      } else if (value) {
        el.classList.add('dh-psy-masthead--white')
      } else {
        el.classList.remove('dh-psy-masthead--white')
      }
    }
  },
  methods: {
    centerChange(e) {
      this.center = e.center
    },
    topChange(e) {
      this.top = e.top
    },
    bottomChange(e) {
      this.bottom = e.bottom
    }
  },
  components: { InViewport }
}
</script>

<style lang="postcss" scoped>
  .dh-psy-reveal {
    position: relative;
    z-index: 2;
    margin: calc(50px + 1em) auto;

    &.dh-psy-reveal--centered {
      color: #fff;
    }
  }

  .dh-psy-reveal__bg {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    height: calc(100 * var(--dh-vh));
    width: 100%;
    pointer-events: none;
    visibility: hidden;
    opacity: 0;
    z-index: 1;
    transition: opacity ease-in-out 500ms, visibility ease-in-out 500ms;
  }

  .dh-psy-reveal--centered .dh-psy-reveal__bg {
    visibility: visible;

    opacity: 1;
  }

  .dh-psy-reveal__default-bg {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #141517;
  }

  .dh-psy-reveal--centered .dh-psy-reveal__default-bg {
  }
</style>
